// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3zJ7w","large":"styles_large__1QJnw"};